import React from 'react';

const Mission = () => {
  return (
    <main>
      <section className="section" style={{paddingTop: '8rem', backgroundColor: 'white', padding: '8rem 0 6rem 0'}}>
        <div className="container" style={{maxWidth: '1200px', margin: '0 auto', padding: '0 1rem', width: '100%', boxSizing: 'border-box'}}>
          <div className="section-title" style={{textAlign: 'center', marginBottom: '4rem'}}>
            <h1 style={{ 
              fontWeight: 800, 
              marginBottom: '2rem', 
              fontSize: 'clamp(2.5rem, 5vw, 4rem)',
              color: '#AA5B52'
            }}>Our Mission</h1>
            <p style={{ 
              fontSize: 'clamp(1.1rem, 3vw, 1.6rem)', 
              lineHeight: 1.6, 
              maxWidth: '850px', 
              margin: '0 auto 3.5rem',
              color: '#666',
              padding: '0 1rem'
            }}>At Afterimage, we're on a mission to transform healthcare by creating accountability and incentives for diagnostic excellence.</p>
          </div>
          
          <div className="mission-grid" style={{
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', 
            gap: '2rem', 
            padding: '0 1rem'
          }}>
            <div className="mission-card" style={{ 
              boxShadow: '0 8px 25px rgba(170,91,82,0.08)', 
              padding: 'clamp(2rem, 4vw, 2.5rem)',
              background: 'linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)',
              borderRadius: '2rem',
              border: '1px solid #e3f2fd'
            }}>
              <div className="mission-icon" style={{ 
                fontSize: 'clamp(2rem, 4vw, 3rem)', 
                fontWeight: 700,
                color: '#2D5B7B',
                marginBottom: '1.5rem'
              }}>🌍</div>
              <h3 style={{ 
                fontSize: 'clamp(1.3rem, 3vw, 2.1rem)', 
                marginBottom: '1.25rem', 
                fontWeight: 700,
                color: '#2D5B7B'
              }}>Patient Advocacy</h3>
              <p style={{ 
                fontSize: 'clamp(1rem, 2.5vw, 1.25rem)', 
                lineHeight: 1.7,
                color: '#444',
                marginBottom: '1rem'
              }}>We empower patients to verify their diagnoses and medical treatments, ensuring they receive the highest quality care possible.</p>
              <p style={{ 
                fontSize: 'clamp(1rem, 2.5vw, 1.25rem)', 
                lineHeight: 1.7,
                color: '#444'
              }}>By giving patients the tools to validate their care, we help identify potential issues before they cause long-term harm.</p>
            </div>
            <div className="mission-card" style={{ 
              boxShadow: '0 8px 25px rgba(255,193,7,0.08)', 
              padding: 'clamp(2rem, 4vw, 2.5rem)',
              background: 'linear-gradient(135deg, #fff8e1 0%, #fff3c4 100%)',
              borderRadius: '2rem',
              border: '1px solid #ffe082'
            }}>
              <div className="mission-icon" style={{ 
                fontSize: 'clamp(2rem, 4vw, 3rem)', 
                fontWeight: 700,
                color: '#f57c00',
                marginBottom: '1.5rem'
              }}>⚡</div>
              <h3 style={{ 
                fontSize: 'clamp(1.3rem, 3vw, 2.1rem)', 
                marginBottom: '1.25rem', 
                fontWeight: 700,
                color: '#f57c00'
              }}>Quality Improvement</h3>
              <p style={{ 
                fontSize: 'clamp(1rem, 2.5vw, 1.25rem)', 
                lineHeight: 1.7,
                color: '#444',
                marginBottom: '1rem'
              }}>By identifying systemic issues, we help healthcare institutions implement better processes that catch potential errors before they impact patients.</p>
              <p style={{ 
                fontSize: 'clamp(1rem, 2.5vw, 1.25rem)', 
                lineHeight: 1.7,
                color: '#444'
              }}>Our data-driven approach gives providers actionable insights that lead to measurable improvements in diagnostic accuracy.</p>
            </div>
            <div className="mission-card" style={{ 
              boxShadow: '0 8px 25px rgba(170,91,82,0.08)', 
              padding: 'clamp(2rem, 4vw, 2.5rem)',
              background: 'linear-gradient(135deg, #f3e5f5 0%, #e8eaf6 100%)',
              borderRadius: '2rem',
              border: '1px solid #d1c4e9'
            }}>
              <div className="mission-icon" style={{ 
                fontSize: 'clamp(2rem, 4vw, 3rem)', 
                fontWeight: 700,
                color: '#AA5B52',
                marginBottom: '1.5rem'
              }}>🔄</div>
              <h3 style={{ 
                fontSize: 'clamp(1.3rem, 3vw, 2.1rem)', 
                marginBottom: '1.25rem', 
                fontWeight: 700,
                color: '#AA5B52'
              }}>System Transformation</h3>
              <p style={{ 
                fontSize: 'clamp(1rem, 2.5vw, 1.25rem)', 
                lineHeight: 1.7,
                color: '#444',
                marginBottom: '1rem'
              }}>Our work creates incentives for healthcare providers to adopt preventative error detection and continuously improve diagnostic accuracy.</p>
              <p style={{ 
                fontSize: 'clamp(1rem, 2.5vw, 1.25rem)', 
                lineHeight: 1.7,
                color: '#444'
              }}>We're changing the paradigm from reactive to proactive, making error detection a standard part of care rather than an afterthought.</p>
            </div>
          </div>
          
          <div style={{
            marginTop: '5rem', 
            padding: 'clamp(2rem, 4vw, 4rem)', 
            background: 'linear-gradient(135deg, #fff8f5 0%, #f7e6e1 100%)', 
            borderRadius: '2rem', 
            boxShadow: '0 8px 25px rgba(170,91,82,0.08)',
            border: '1px solid #f0f0f0'
          }}>
            <h2 style={{ 
              fontWeight: 700, 
              marginBottom: '2.5rem', 
              fontSize: 'clamp(2rem, 4vw, 3.2rem)',
              color: '#AA5B52',
              textAlign: 'center'
            }}>Our Values</h2>
            <div style={{
              display: 'grid', 
              gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', 
              gap: 'clamp(2rem, 4vw, 3rem)', 
              marginTop: '2rem'
            }}>
              <div>
                <h3 style={{ 
                  fontSize: 'clamp(1.3rem, 3vw, 2.1rem)', 
                  marginBottom: '1rem', 
                  fontWeight: 700,
                  color: '#2D5B7B'
                }}>Patient-Centered</h3>
                <p style={{ 
                  fontSize: 'clamp(1rem, 2.5vw, 1.25rem)', 
                  lineHeight: 1.7,
                  color: '#444'
                }}>Every decision we make puts patients first, ensuring they receive accurate diagnoses and appropriate care.</p>
              </div>
              <div>
                <h3 style={{ 
                  fontSize: 'clamp(1.3rem, 3vw, 2.1rem)', 
                  marginBottom: '1rem', 
                  fontWeight: 700,
                  color: '#f57c00'
                }}>Evidence-Based</h3>
                <p style={{ 
                  fontSize: 'clamp(1rem, 2.5vw, 1.25rem)', 
                  lineHeight: 1.7,
                  color: '#444'
                }}>We rely on data and scientific evidence to guide our approach to improving healthcare quality.</p>
              </div>
              <div>
                <h3 style={{ 
                  fontSize: 'clamp(1.3rem, 3vw, 2.1rem)', 
                  marginBottom: '1rem', 
                  fontWeight: 700,
                  color: '#AA5B52'
                }}>Collaborative</h3>
                <p style={{ 
                  fontSize: 'clamp(1rem, 2.5vw, 1.25rem)', 
                  lineHeight: 1.7,
                  color: '#444'
                }}>We work alongside healthcare providers, not against them, to create sustainable improvements in care delivery.</p>
              </div>
              <div>
                <h3 style={{ 
                  fontSize: 'clamp(1.3rem, 3vw, 2.1rem)', 
                  marginBottom: '1rem', 
                  fontWeight: 700,
                  color: '#2D5B7B'
                }}>Innovative</h3>
                <p style={{ 
                  fontSize: 'clamp(1rem, 2.5vw, 1.25rem)', 
                  lineHeight: 1.7,
                  color: '#444'
                }}>We embrace cutting-edge technology and creative solutions to tackle longstanding challenges in healthcare.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Mission; 